/**
 * 条件分岐の通し番号チップ。分岐元の質問の見出しと、その質問の帯の両方に同じ番号を出して対応づける。
 *
 * MUI の Chip は size="small" でも高さ 24px で、帯(24px、ボーダー込み)には収まらない。
 * 高さ・余白・アイコン余白をすべて上書きすることになるため、Stack で必要な見た目だけを組む。
 */
import { colors } from '@kmns-internal/furikake'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { BAND_CONTENT_HEIGHT } from '../model'

type Props = {
  logicNumber: number
  /** 背景を敷かない。帯の中のように、地の色と同じで意味のない箱に見えてしまう場所で使う。 */
  disableBackground?: boolean
}

export const LogicNumberChip = ({ logicNumber, disableBackground }: Props) => (
  // アイコンだけでは読み上げに意味が出ないため、チップ全体を 1 つのラベル付き要素として扱う。
  <Stack
    role="img"
    aria-label={`条件分岐 ${logicNumber}`}
    direction="row"
    spacing={0.25}
    alignItems="center"
    sx={theme => ({
      flex: '0 0 auto',
      height: BAND_CONTENT_HEIGHT(theme),
      color: colors.primary.main,
      ...(disableBackground
        ? {}
        : {
            px: 0.5,
            borderRadius: theme.shape.borderRadius,
            bgcolor: colors.primary.selected,
          }),
    })}
  >
    <AccountTreeIcon sx={{ fontSize: 14 }} />
    <Typography variant="caption" fontWeight={700} lineHeight={1}>
      {logicNumber}
    </Typography>
  </Stack>
)
